// extracted by mini-css-extract-plugin
export default {"DeliveryContainer":"styles_DeliveryContainer__otS91","livdomContainer":"styles_livdomContainer__hI5jK"};